/**
 * Loading View
 *
 * Displays a loading spinner during authentication check.
 * Shown when the app is initializing and checking auth status.
 */

import { createSpinner, renderIcon } from '../utils/icons';

/**
 * Create the loading view element
 */
export function createLoadingView(): HTMLElement {
  const container = document.createElement('div');
  container.className = 'min-h-screen flex items-center justify-center p-4';

  // Create glass card container
  const card = document.createElement('div');
  card.className = 'glass-card w-full max-w-md p-8 rounded-2xl text-center';

  // Logo section
  const logoSection = document.createElement('div');
  logoSection.className = 'flex justify-center mb-6';
  logoSection.innerHTML = `
    <div class="w-16 h-16 rounded-xl bg-primary/20 flex items-center justify-center">
      ${renderIcon('briefcase', { size: 'xl', className: 'text-primary' }).outerHTML}
    </div>
  `;

  // Loading section
  const loadingSection = document.createElement('div');
  loadingSection.className = 'space-y-4';

  const spinnerContainer = document.createElement('div');
  spinnerContainer.className = 'flex justify-center';
  spinnerContainer.appendChild(createSpinner({ size: 'lg', className: 'text-primary' }));

  const textContent = document.createElement('div');
  textContent.innerHTML = `
    <h2 class="text-lg font-semibold text-foreground mb-1">Loading</h2>
    <p class="text-muted-foreground text-sm">Checking authentication status...</p>
  `;

  loadingSection.appendChild(spinnerContainer);
  loadingSection.appendChild(textContent);

  // Assemble card
  card.appendChild(logoSection);
  card.appendChild(loadingSection);

  container.appendChild(card);

  return container;
}

/**
 * Loading view renderer for router
 */
export function loadingView(): HTMLElement {
  return createLoadingView();
}

export default loadingView;
